import { SettingSource, SettingStore } from '../SettingStore';
import { loadModuleDirectly } from '../../../../@Util/DependencyInjection/Injection/DependencyInjection';

export default async function setSetting<T>(type: SettingSource, code: string, value?: T, logChanges: boolean = false)
{
    return loadModuleDirectly(SettingStore).updateWithValue(type, code, value, logChanges);
}
